const SET_BASE_URL = 'SET_BASE_URL';
export default SET_BASE_URL;